import type { NextPage } from 'next'
// import { useRouter } from 'next/router'
// import Link from 'next/link'
// import { useState } from 'react'

// import type { Item } from '@/modules/project'
import Dayjs from '@/components/dayjs'
import style from './item.module.css'

import AttachFileTable from './AttachFileTable'
import {Draft} from "@/modules/project";
import BlankPage from "@/components/pages/project/blank";


interface IProps {
    className?: string
    item?: Draft
}

const Component: NextPage<IProps> = ({ className , item}) => {
  const title = '초안'
  return (
    <section className={className || ''}>
      <h3 className={style.h3}>
          {title}
      </h3>
      {
        item && item.idx?
            (
                <>
                    <div>
                        <table className={`${style.baseInfoTable} border-t-2 border-t-gg-blue`}>
                            <colgroup>
                                <col width={200}/>
                                <col width={400}/>
                                <col width={200}/>
                                <col width={400}/>
                            </colgroup>
                            <tbody>
                            <tr>
                                <th>공람기간</th>
                                <td><Dayjs format="dateDot">{item?.publicDisplayStartDate}</Dayjs> ~ <Dayjs format="dateDot">{item?.publicDisplayEndDate}</Dayjs></td>
                                <th>접수일</th>
                                <td><Dayjs format="dateDot">{item?.registeredDate}</Dayjs></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='my-8'>
                        <AttachFileTable title="평가서" items={item?.files}/>
                    </div>
                </>
            )
            :
            (
                <BlankPage title={title} className="mb-12" />
            )
      }
    </section>
  )
}

export default Component
